import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'text-button',
  templateUrl: './text-button.component.html',
  styleUrls: ['./text-button.component.css']
})
export class TextButtonComponent implements OnInit {

  @Input() color: string = "white";
  @Input() highlight: string = "rgba(255, 255, 255, 0.3"
  constructor() { 

  }

  ngOnInit(): void {

  }

}
